<template>
  <v-card
    :disabled="loading"
    :loading="loading"
  >
    <v-card-title>
      <h2>{{ $t("officer_config.config_project") }}</h2>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab
          v-for="(level, i) in levels"
          :key="i"
        >
          <h3>{{ objectTranslator(level, "LEVEL_NAME") }}</h3>
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="level_tab"
        touchless
      >
        <v-tab-item
          v-for="(level, i) in levels"
          :key="i"
        >
          <ConfigProjectDisplay
            :level_id="level.LEVEL_ID"
            :config_years="config_years"
            :toggle_loading="toggle_loading"
          ></ConfigProjectDisplay>

        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import ConfigProjectDisplay from "./ConfigProjectDisplay";
import { createHelpers } from "vuex-map-fields";
import { objectTranslator } from "@/helper/translator";

const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

export default {
  name: "ConfigProject",
  data: function () {
    return {
      loading: false,
      level_tab: null,
    };
  },
  components: {
    ConfigProjectDisplay,
  },
  computed: {
    levels() {
      return this.$store.state.ref.levels;
    },
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },
  methods: {
    objectTranslator,
    toggle_loading(status) {
      this.loading = status;
    },
  },
  created: function () {
    this.$store.dispatch("ref/getLevels");
    this.$store.dispatch("officerConfig/getYears");
  },
};
</script>
